import { Box } from '@factorialco/deprecated-design-system'
import { TwoColumnLayout } from '@factorialco/f0-react'
import { QuoteDetailFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import MainContent from 'modules/finance/components/Quotes/QuotesDetail/_MainContent'

interface QuoteDetailProps {
  quote: QuoteDetailFragment
}

const QuoteDetail = ({ quote }: QuoteDetailProps) => {
  const { access } = useCurrentSession()
  const locale = access.locale

  return (
    <Box border={{ top: { style: 'solid', width: 's1', color: 'grey400' } }}>
      <TwoColumnLayout sideContent={<></>}>
        <MainContent quote={quote} locale={locale} />
      </TwoColumnLayout>
    </Box>
  )
}

export default QuoteDetail
